<template>
  <div class="container">
    <div style="margin-bottom: 20px;">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText"
                style="width: 260px; margin-right: 10px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadTeamList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="teamList" class="table-border" v-loading="loading" header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="工组名称" prop="name" width="100"></el-table-column>
      <el-table-column label="工作范围">
        <template #default="{row}">
          <div>{{row.procedureIdList | valueName('DispatchableProcedure')}}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column label="状态" width="60">
        <template #default="{row}">
          <div>{{row.status | status}}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button v-if="isRoot" type="text" @click="edit(row)" size="mini">编辑</el-button>
          <el-button v-else type="text" @click="edit(row)" size="mini">
            {{(readOnly || !row.editable) ? '查看' : '编辑'}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button v-if="isRoot" type="text" @click="deleteTeam(row)" size="mini" class="danger">
            删除
          </el-button>
          <el-button v-else :disabled="!row.editable" type="text" size="mini" @click="deleteTeam(row)"
                     class="danger">删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <edit-team-dialog :visible.sync="dialog.show"
                      :team-id="dialog.teamId"
                      :read-only="!isRoot && readOnly"></edit-team-dialog>
  </div>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import EditTeamDialog from '@/views/team/EditTeamDialog'
  import authority from '@/utils/authority'

  export default {
    name: 'TeamList',
    components: { EditTeamDialog },
    mixins: [shareDataMixin],
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          teamId: null
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('team/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.teamId = null
        this.dialog.show = true
      },
      edit (team) {
        this.dialog.teamId = team.id
        this.dialog.show = true
      },
      deleteTeam (team) {
        this.$confirm(`确认删除工组【${team.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('team/delete', team.id).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadTeamTemplate'
      },
      teamList () {
        const list = this.$store.state.team.teamList
        if (!this.searchText) return list

        return list.filter(team => team.name.indexOf(this.searchText) !== -1)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_TEAM)
      },
      addable () {
        return this.$hasPermission(authority.ADD_TEAM)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_TEAM)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    th {
      height: 50px;
    }
  }
</style>
